import Helmet from 'react-helmet';

import { AppContainer } from 'twyne-new.ui';

import { useGrid } from '../context';

export default function Wrapper({ children, className }) {
  const { definitions } = useGrid()

  if (!definitions) {
    return null
  }

  return <>
    <AppContainer direction='vertical' className={className}>
      <Helmet title={definitions.entityNamePlural} />
      {children}
    </AppContainer>
  </>
}
